<template>
  <div class="c-app role-theme-app" :class="{ 'c-dark-theme': $store.state.darkMode }">
    <TheHeader />
    
    <TheSidebar />

    <div
      class="c-wrapper"
      :class="{
        'sidebar-open': $store.state.sidebarShow && !$store.state.sidebarMinimize,
        'sidebar-minimized': $store.state.sidebarMinimize
      }"
    >
      <div class="c-body">
        <main class="c-main">
          <CContainer fluid>
            <router-view></router-view>
          </CContainer>
        </main>
        <TheFooter />
      </div>
    </div>

    <RoleBottomNav role="supervisor" />

    <!-- Global Floating Report Action Button -->
    <FloatingReportFab />

    <CenterLoading />
    <DialogMessage />
    <SignIn />
  </div>
</template>

<script>
import TheSidebar from './TheSidebar'
import TheHeader from './TheHeader'
import TheFooter from '../TheFooter'
import RoleBottomNav from '@/components/common/RoleBottomNav.vue'
import FloatingReportFab from '@/components/common/FloatingReportFab.vue'
import { mapActions } from "vuex";

export default {
  name: 'TheContainer',
  components: { TheSidebar, TheHeader, TheFooter, RoleBottomNav, FloatingReportFab },
  mounted() {
    document.body.classList.add('role-unified-theme');
    this.loadUserProfile();
  },
  beforeDestroy() { document.body.classList.remove('role-unified-theme'); },
  methods: {
    ...mapActions("user", ["getProfile"]),
    async loadUserProfile() { try { await this.getProfile(); } catch (err) { console.error(err); } },
  },
};
</script>

<style scoped>
.c-wrapper {
  margin-left: 0;
  transition: margin-left 0.3s ease;
}

/* ดันเนื้อหาลงมา 60px เพื่อไม่ให้โดน Header บัง */
.c-body {
  padding-top: 82px !important;
}

@media (min-width: 1201px) {
  .sidebar-open { margin-left: 250px !important; }
  .sidebar-minimized { margin-left: 70px !important; }
}
</style>
